import React from "react";
import { useTranslation } from "react-i18next";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function StripePay({ checkoutWithStripePay, isStripePaySelected }) {
  const { t } = useTranslation();

  return (
    <div
      className={`stripe-pay-card ${isStripePaySelected ? "stripe-pay-card--selected" : ""}`}
      onClick={() =>
        checkoutWithStripePay({
          selected: true,
          payment_by: "stripe_payment",
        })
      }
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          checkoutWithStripePay({ selected: true, payment_by: "stripe_payment" });
        }
      }}
    >
      <div className="stripe-pay-card__left">
        <div className="stripe-pay-card__radio">
          <span className={`stripe-pay-card__radio-dot ${isStripePaySelected ? "is-checked" : ""}`} />
        </div>

        <CreditCardOutlinedIcon className="stripe-pay-card__icon" style={{ fontSize: "1.3rem" }} />

        <div className="stripe-pay-card__text">
          <span className="stripe-pay-card__title">{t("Credit / Debit Card")}</span>
          <span className="stripe-pay-card__subtitle">{t("Pay securely")}</span>
        </div>
      </div>

      <div className="stripe-pay-card__right">
        <span className="stripe-pay-card__methods">Visa · Mastercard · Apple Pay · Google Pay</span>
        {isStripePaySelected && (
          <CheckCircleIcon className="stripe-pay-card__check" style={{ fontSize: "1.15rem" }} />
        )}
      </div>

      <style>{`
        .stripe-pay-card {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          width: 100%;
          padding: 14px 18px;
          border: 1.5px solid #e5e7eb;
          border-radius: 12px;
          background: #ffffff;
          cursor: pointer;
          transition: border-color 0.15s ease, background 0.15s ease;
          outline: none;
        }

        .stripe-pay-card:hover {
          border-color: #d1d5db;
        }

        .stripe-pay-card:focus-visible {
          border-color: #404040;
          box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.12);
        }

        .stripe-pay-card--selected {
          border-color: #404040;
          background: #fffaf5;
        }

        .stripe-pay-card__left {
          display: flex;
          align-items: center;
          gap: 12px;
          min-width: 0;
        }

        .stripe-pay-card__radio {
          flex-shrink: 0;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          border: 2px solid #d1d5db;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .stripe-pay-card--selected .stripe-pay-card__radio {
          border-color: #404040;
        }

        .stripe-pay-card__radio-dot {
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background: transparent;
        }

        .stripe-pay-card__radio-dot.is-checked {
          background: #404040;
        }

        .stripe-pay-card__icon {
          flex-shrink: 0;
          color: #6b7280;
        }

        .stripe-pay-card--selected .stripe-pay-card__icon {
          color: #404040;
        }

        .stripe-pay-card__text {
          display: flex;
          flex-direction: column;
          min-width: 0;
        }

        .stripe-pay-card__title {
          font-size: 14.5px;
          font-weight: 600;
          color: #111827;
        }

        .stripe-pay-card__subtitle {
          font-size: 12.5px;
          color: #9ca3af;
          margin-top: 1px;
        }

        .stripe-pay-card__right {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-shrink: 0;
        }

        .stripe-pay-card__methods {
          font-size: 12.5px;
          color: #9ca3af;
          white-space: nowrap;
        }

        .stripe-pay-card__check {
          color: #404040;
        }

        @media (max-width: 560px) {
          .stripe-pay-card {
            padding: 12px 14px;
          }
          .stripe-pay-card__subtitle,
          .stripe-pay-card__methods {
            display: none;
          }
        }
      `}</style>
    </div>
  );
}

export default StripePay;